import { render, staticRenderFns } from "./CmgRecipesBanner.vue?vue&type=template&id=15cf3e46&scoped=true&lang=pug"
import script from "./cmg-recipes-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-recipes-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRecipesBanner.vue?vue&type=style&index=0&id=15cf3e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf3e46",
  null
  
)

export default component.exports